import {useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input,} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import {useBnsXiangMuXuQiuUpdateQuery, useBnsXiangMuXuQiuUpdateSaveMutation } from '../../store/BnsKeJiApi';
import MyEditor from '../../cpn/MyEditor';
function ModuleEdit(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        setOpen(false);
    };
    const [info,setInfo] = useState({
        'bxmxq_id': props.bxmxq_id,
        'bxmxq_bxm_name': props.bxm_name,
        'bxmxq_name': '',
        'bxmxq_content': '',
        'bxmxq_cid': props.eu_id,
        'bxmxq_cname': props.eu_name,
        'bxmxq_bxm_id': props.bxm_id,
    }); 
    const {data,isSuccess} = useBnsXiangMuXuQiuUpdateQuery({bxmxq_id:props.bxmxq_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bxmxq_content:data.Result.bxmxq_content,
                    bxmxq_name:data.Result.bxmxq_name,
                })
                setInfo(prevState=>({...prevState,         
                    bxmxq_content:data.Result.bxmxq_content,                         
                    bxmxq_name:data.Result.bxmxq_name,    
                    bxmxq_yh_id:data.Result.bxmxq_yh_id,    
                    bxmxq_yh_name:data.Result.bxmxq_yh_name,    
                    bxmxq_bxm_id:data.Result.bxmxq_bxm_id,    
                    bxmxq_bxm_name:data.Result.bxmxq_bxm_name,  
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsXiangMuXuQiuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改模块'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_module_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                     <Form.Item 
                        name="bxmxq_name" 
                        label='模块名称' 
                        wrapperCol={{span:20}} 
                        required
                    >
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bxmxq_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item 
                        name="bxmxq_content" 
                        label='模块说明' 
                        wrapperCol={{span:21}}                            
                    >
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,bxmxq_content:e}))}}/>
                    </Form.Item>  
                </Form>
            </Modal>
        </>
    )
}

export default ModuleEdit
